import { render, staticRenderFns } from "./UiCheckboxInput.vue?vue&type=template&id=78a8e656"
import script from "./UiCheckboxInput.vue?vue&type=script&lang=js"
export * from "./UiCheckboxInput.vue?vue&type=script&lang=js"
import style0 from "./UiCheckboxInput.vue?vue&type=style&index=0&id=78a8e656&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports